export default "__VITE_ASSET__Djoq_uOm__"